export default __webpack_public_path__ + "images/9daa13cdce6db7b765637e06926c024e-cartebancaire@2x.png";